export default __webpack_public_path__ + "static/media/TVinsure-Covid-1.55651419.png";